export default __webpack_public_path__ + "cda5f37d77e1e88dee7c8c951e74529e.png";